/** Shared input class for password fields with show/hide toggle. */
export const passwordInputClass =
  "text-body-base text-charcoal border border-border-subtle px-3 py-2 bg-white focus:outline-none focus:border-accent-green transition-colors w-full min-h-[44px] pr-12";

/** Returns the password rules checklist for a given password value. */
export function getPasswordRules(password: string) {
  return [
    { label: "At Least 8 Characters", met: password.length >= 8 },
    { label: "Includes One Uppercase Letter", met: /[A-Z]/.test(password) },
    { label: "Includes One Lowercase Letter", met: /[a-z]/.test(password) },
    { label: "Includes One Number", met: /[0-9]/.test(password) },
    {
      label: "Includes One Special Character (E.G. ! @ # $ %)",
      met: /[!-/:-@[-`{-~]/.test(password),
    },
  ];
}
